export const commitSha = import.meta.env.VITE_CI_COMMIT_SHA;
